/* global $, window, document */

const scriptActivation = true;
let activeCOD = false;
const CODCoupon = "COD5%";

// Separate containers for page and drawer
let paymentInfoDivPage = $('<div id="paymentInfoDivPage"></div>');
let paymentInfoDivDrawer = $('<div id="paymentInfoDivDrawer"></div>');
let typePaymentDivPage = $('<div id="typePaymentDivPage"></div>');
let typePaymentDivDrawer = $('<div id="typePaymentDivDrawer"></div>');

let isDepositEnabled = false;
let modalShown = false;
let justSwitchedToFull = false; // guard after switching to Full

// Hide 100% badge if present
let badgeSaleSpan = $('.t4s-badge-sale');
if (badgeSaleSpan.text().indexOf('100%') !== -1) {
  badgeSaleSpan.hide();
}
badgeSaleSpan = null;

if (scriptActivation) $(document).ready(function () {
  // Ensure radios reflect the default before rendering
  isDepositEnabled = activeCOD;

  console.log(`docReady start with : ${activeCOD} `);
  $se(linkCartBtns);
  $se(adjustSticky);
  $se(addTypePaymentDiv);
  $se(addPaymentDivs);
  $se(bindToggleHandlers); // delegated for resilience
  $se(interceptCheckoutClicks);
  $se(checkIfCouponApplied);
  $se(genCartElemnts);
  $se(groupColors);
  $se(updPriceinSticky);
  $se(forceImageInDrpDwn);
  $se(showThumbsOnDrp);
  $se(showProperDimensions);
  $se(hidePriceWhenZero);
  $se(notifyFor50Cm);
  $se(addBYBbadge);
  $se(readCoupon);
  $se(maskCODOrderDiscountLine); // hide li.t4s-order_cart_discounts for COD5%

  // Initialize checkout link discount state on load (no discount for Full)
  updateCheckoutLinkDiscount(activeCOD ? CODCoupon : null);

  console.log("docReady finished");
});

// ------------ COD helpers and toggles ------------

// Update checkout buttons to add/remove ?discount=
function updateCheckoutLinkDiscount(codeOrNull) {
  $('a[href^="/checkout"]').each(function () {
    try {
      const url = new URL(this.getAttribute('href'), window.location.origin);
      url.searchParams.delete('discount');
      if (codeOrNull) url.searchParams.set('discount', codeOrNull);
      this.setAttribute('href', url.pathname + url.search);
    } catch (e) {
      // Ignore invalid/relative hrefs
    }
  });
}

// Force checkout navigation to honor current state (covers drawer/buttons not using href)
function interceptCheckoutClicks() {
  $(document).off('click.cod')
    .on('click.cod', 'a[href^="/checkout"], button[name="checkout"], .t4s-btn-checkout, .button_checkout', function (e) {
      try {
        const isAnchor = this.tagName === 'A';
        if (isAnchor) {
          const url = new URL(this.href, window.location.origin);
          const hasParam = url.searchParams.has('discount');
          const shouldHave = activeCOD;
          if (shouldHave && (!hasParam || url.searchParams.get('discount') !== CODCoupon)) {
            e.preventDefault();
            url.searchParams.set('discount', CODCoupon);
            window.location.href = url.pathname + url.search;
            return;
          }
          if (!shouldHave && hasParam) {
            e.preventDefault();
            url.searchParams.delete('discount');
            window.location.href = url.pathname + url.search;
            return;
          }
          return; // already correct
        }
      } catch (err) { /* fall through */ }
      // Generic fallback
      e.preventDefault();
      window.location.href = activeCOD
        ? `/checkout?discount=${encodeURIComponent(CODCoupon)}`
        : '/checkout';
    });
}

// Find applied COD discount tags (from the discount app)
function $findCODTags() {
  const byKey = $(`.ppl_close_dis_tag[data-key="${CODCoupon}"]`);
  if (byKey.length) return byKey;

  return $('.ppl_dis_tags_wrapper .ppl_tag_holder')
    .filter(function () {
      return $(this).text().indexOf(CODCoupon) !== -1;
    })
    .find('.ppl_close_dis_tag');
}

function disCOD() {
  activeCOD = false;

  // Remove any COD discount tags
  const $closeBtns = $findCODTags();
  if ($closeBtns.length) $closeBtns.each(function () { $(this).click(); });

  // Clear UI immediately to avoid lingering deposit values
  setPaymentInfoDiv('');

  // Ensure checkout links do not carry ?discount
  updateCheckoutLinkDiscount(null);

  // Prevent showing discount rows while app updates
  justSwitchedToFull = true;

  // Refresh UI
  setTimeout(updateCartElmnts, 200);
}

function enCOD() {
  // Remove all other discount tags first (keep only our COD one)
  const $others = $(`.ppl_dis_tags_wrapper .ppl_tag_holder`).filter(function () {
    return $(this).text().indexOf(CODCoupon) === -1;
  }).find('.ppl_close_dis_tag');
  if ($others.length) $others.each(function () { $(this).click(); });

  activeCOD = true;
  justSwitchedToFull = false;

  // Apply our COD coupon through the discount app UI
  setTimeout(function () {
    const $input = $('.ppl_dis_input, .ppl-dis-input').first();
    const $apply = $('.ppl_dis_apply, .ppl-dis-apply').first();
    if ($input.length) $input.val(CODCoupon);
    if ($apply.length) $apply.click();
  }, 300);

  // Add discount param to checkout links
  updateCheckoutLinkDiscount(CODCoupon);

  // Refresh UI
  setTimeout(updateCartElmnts, 400);
}

// Keep discount state sane and UI in sync
function checkIfCouponApplied() {
  const hasCOD = $findCODTags().length > 0 || $(`.ppl_dis_tags_wrapper:has(:contains("${CODCoupon}"))`).length > 0;
  const isLoading = $(".ppl_dis_apply, .ppl-dis-apply").children(".ppl_spinner-border").length > 0;
  const tagsCount = $('.ppl_dis_tags_wrapper').children().length;

  if (activeCOD) {
    if (!hasCOD && !isLoading) enCOD();
    if (tagsCount > 1) {
      $(`.ppl_dis_tags_wrapper .ppl_tag_holder`).filter(function () {
        return $(this).text().indexOf(CODCoupon) === -1;
      }).find('.ppl_close_dis_tag').each(function () { $(this).click(); });
    }
    updateCheckoutLinkDiscount(CODCoupon);
  } else {
    if (hasCOD && !isLoading) {
      const $codBtns = $findCODTags();
      if ($codBtns.length) $codBtns.each(function () { $(this).click(); });
    }
    updateCheckoutLinkDiscount(null);
  }

  // Re-render radio UI if state changed
  if (activeCOD !== isDepositEnabled || isDepositEnabled == null) {
    isDepositEnabled = activeCOD;
    setTimeout(function () {
      addTypePaymentDiv();
      addPaymentDivs();
      bindToggleHandlers();
    }, 200);
  }
}

// ------------ Payment toggle UI (page + drawer) ------------

function addTypePaymentDiv() {
  const htmlFor = (prefix) => `
<div class="btn-group mcgp" role="group">
  <input name="btnradio_${prefix}" type="radio" class="btn-check" id="codON_${prefix}" autocomplete="off" ${isDepositEnabled == true ? "checked" : ""}>
  <label class="btn btn-outline-primary mcg-btn" for="codON_${prefix}">Pay Deposit</label>
  <input type="radio" class="btn-check" name="btnradio_${prefix}" id="codOFF_${prefix}" autocomplete="off" ${isDepositEnabled == false ? "checked" : ""}>
  <label class="btn btn-outline-primary mcg-btn" for="codOFF_${prefix}">Pay Full Amount</label>
</div>`;

  typePaymentDivPage.html(htmlFor('page'));
  typePaymentDivDrawer.html(htmlFor('drawer'));
}

function bindToggleHandlers() {
  // Delegated handlers survive drawer re-renders
  $(document)
    .off('change.codUI')
    .on('change.codUI', '#codON_page, #codON_drawer', enCOD)
    .on('change.codUI', '#codOFF_page, #codOFF_drawer', disCOD);
}

function setPaymentInfoDiv(html) {
  paymentInfoDivPage.html(html);
  paymentInfoDivDrawer.html(html);
}

function addPaymentDivs() {
  // Cart page
  const $cartTax = $('.t4s-cart__tax').first();
  if ($cartTax.length) {
    if (!$.contains(document, typePaymentDivPage[0])) $cartTax.prepend(typePaymentDivPage);
    if (!$.contains(document, paymentInfoDivPage[0])) $cartTax.prepend(paymentInfoDivPage);
  }

  // Cart drawer (cover common theme footers)
  const $drawerFooter = $('.t4s-mini_cart__footer, .t4s-drawer__footer, .t4s-mini_cart .t4s-cart__tax, .t4s-mini_cart__content .t4s-cart__tax').first();
  if ($drawerFooter.length) {
    if (!$.contains(document, typePaymentDivDrawer[0])) $drawerFooter.prepend(typePaymentDivDrawer);
    if (!$.contains(document, paymentInfoDivDrawer[0])) $drawerFooter.prepend(paymentInfoDivDrawer);
  }
}

// ------------ Totals rendering (shared for page + drawer) ------------

function updateCartElmnts() {
  checkIfCouponApplied();

  // Prefer totals inside cart drawer/page contexts, not product tiles
  const contexts = [];
  const $drawer = $('.t4s-mini_cart, .t4s-drawer__inner, .t4s-mini_cart__content').first();
  if ($drawer.length) contexts.push($drawer);
  const $drawerFooter = $('.t4s-mini_cart__footer, .t4s-drawer__footer').first();
  if ($drawerFooter.length) contexts.push($drawerFooter);
  const $cartPage = $('.t4s-cart, .t4s-main-cart, .t4s-cart__form').first();
  if ($cartPage.length) contexts.push($cartPage);
  const $cartTax = $('.t4s-cart__tax').first();
  if ($cartTax.length) contexts.push($cartTax);

  // Dedup contexts
  const uniqContexts = [];
  contexts.forEach(($c) => { if ($c.length && !uniqContexts.some(u => u[0] === $c[0])) uniqContexts.push($c); });

  const readTotals = ($ctx) => {
    return {
      originalPrice: ($ctx.find('[data-original], .t4s-cart__subtotal, .t4s-mini_cart__subtotal').first().text() || '').trim(),
      discountPrice: ($ctx.find('[data-discount], .t4s-mini_cart__discount').first().text() || '').trim(),
      finalPrice: ($ctx.find('[data-discounted], .t4s-mini_cart__final').first().text() || '').trim(),
      totalPrice: ($ctx.find('#cart_final_price, .t4s-mini_cart__footer [data-cart-prices], .t4s-mini_cart__total-price, .t4s-cart__total-price').first().text() || '').trim()
    };
  };

  let data = { originalPrice: '', discountPrice: '', finalPrice: '', totalPrice: '' };
  for (const $ctx of uniqContexts) {
    data = readTotals($ctx);
    if (checkElemsData(data)) break;
  }

  // Final fallback: try whole document only if no context yielded valid data
  if (!checkElemsData(data)) {
    data = readTotals($(document.body));
  }
  if (!checkElemsData(data)) return;

  const { originalPrice, discountPrice, finalPrice, totalPrice } = data;

  const isAppBusy = $(".ppl_dis_apply, .ppl-dis-apply").children(".ppl_spinner-border").length > 0;
  const codTagPresent = $findCODTags().length > 0;

  let togHTML = "";
  if (activeCOD) {
    // Deposit view
    togHTML += `<div style="display:flex;justify-content:space-between;"></div>`;
    togHTML += `<div style="display:flex;justify-content:space-between;"> <span>Total price</span> <span>${originalPrice}</span></div>`;
    togHTML += `<div style="display:flex;justify-content:space-between;"> <span>Pay on Delivery of Goods</span> <span>${(discountPrice || '').replace(/-/g, '')}</span></div>`;
    togHTML += `<div style="display:flex;justify-content:space-between;"> <span><strong>Pay Now</strong></span> <span><strong>${finalPrice}</strong></span></div>`;
    setPaymentInfoDiv(togHTML);
  } else {
    // Full payment view
    const suppressDiscountRows = codTagPresent || isAppBusy || justSwitchedToFull;

    if (!suppressDiscountRows && discountPrice) {
      const rs = extractNumericValue(originalPrice) - extractNumericValue(discountPrice);
      togHTML += `<div style="display:flex;justify-content:space-between;"> <span>Subtotal</span> <span>${originalPrice}</span></div>`;
      togHTML += `<div style="display:flex;justify-content:space-between;"> <span>Discount</span> <span>${discountPrice.replace(/-/g, '')}</span></div>`;
      togHTML += `<div style="display:flex;justify-content:space-between;"> <span><strong>Total</strong></span> <span><strong>£${isFinite(rs) ? rs.toFixed(2) : extractNumericValue(totalPrice).toFixed(2)}</strong></span></div>`;
      setPaymentInfoDiv(togHTML);
    } else {
      const safeTotal = (totalPrice || originalPrice || '').replace(/GBP/g, '');
      togHTML += `<div style="display:flex;justify-content:space-between;"> <span><strong>Total price</strong></span> <span><strong>${safeTotal}</strong></span></div>`;
      setPaymentInfoDiv(togHTML);
    }
    // Reset guard after first render in Full mode
    justSwitchedToFull = false;
  }
}

function genCartElemnts() {
  setInterval(function () {
    // Re-attach into drawer if it re-rendered
    addPaymentDivs();
    updateCartElmnts();
  }, 500);
}

// Looser checks so drawer also renders correctly
function checkElemsData(data) {
  let { originalPrice, discountPrice, finalPrice, totalPrice } = data;
  if (activeCOD) {
    return !!(originalPrice && (finalPrice || totalPrice)); // allow discountPrice empty while app updates
  } else {
    return !!(totalPrice || originalPrice);
  }
}

function isCartPage() {
  return window.location.pathname === "/cart";
}

// ------------ Misc existing features (left intact) ------------

function addDepthInfo() {
  const infodiv = ` <div class="info-div"><i class="fa fa-info-circle"></i>Base Height excludes mattress heights..</div>`;
  setInterval(function () {
    let parent = $("body .pplr-depth");
    if (parent.length > 0) {
      if ($('.info-div').length < 1) parent.append(infodiv);
    }
  }, 500);
}

function a() {
  $(".z_discount_input").on("change", function () {
    if ($(this).val().length > 1) disCOD();
  });
}

function readCoupon() {
  $('.ppl-dis-apply, .ppl_dis_apply').on('click', function () {
    var inputBeforeButton = $(this).prevAll('input:first');
    console.log('Input before click:', inputBeforeButton.val());
  });
}

function addBYBbadge(a = false) {
  $('body .t4s-product').each(function () {
    var firstLink = $(this).find('a').first().attr('href');
    var productImg = $(this).find('.t4s-product-info');
    var productOptions = $(this).data('product-options');

    if (productImg.length > 0 && productOptions && productOptions.isDefault === true && !productOptions.isSwatch) {
      const customDiv = `
  <div>
    <a href="${firstLink}" data-sort="sale,new,soldout,preOrder,custom" class="byb-badge">
      <span data-badge-sale="" class="">
        Customize Your Bed
      </span>
    </a>
  </div>
`;
      productImg.prepend(customDiv);
    }
  });
  if (!a) $('.t4s-loadmore-btn').on('click', function () {
    console.log("loaded more");
    addBYBbadge(true);
  });
}

function notifyFor50Cm() {
  setTimeout(function () {
    $('.pplr-swatch-element:contains("50cm")').on('click', function () {
      console.log("50Cm Trigger" + $(this).text());
      showNotifModal('Prior to making a purchase of the 50cm Bed Base, please check the bed base height is suitable for your regular use, please measure your current bed base height.<br> Caculate total bed height by adding the mattress height to the selected bed base height for comparison.');
    });
  }, 1000);
}

function adjustSticky() {
  var $stickyDiv = $("#stickyATC");

  function handleScroll() {
    try {
      var offset = $(window).scrollTop();
      var cartBtnY = $("#addToCartBtn").offset().top;
      var windowheight = $(window).height();
      var viewSticky = offset > cartBtnY || offset < cartBtnY - windowheight;

      if (viewSticky) {
        $stickyDiv.addClass("showSticky");
        $stickyDiv.removeClass("hideSticky");
      }
      else {
        $stickyDiv.addClass("hideSticky");
        $stickyDiv.removeClass("showSticky");
      }
    } catch (e) { /* ignore */ }
  }

  $(window).scroll(handleScroll);
  handleScroll();

  $('[data-cart-count]').on("change", function () {
    alert('count Changed');
  });
}

function linkCartBtns() {
  $('#stickyAddBtn').on('click', function () {
    setTimeout(remSpinner, 1500);
  });
  $('#addToCartBtn').on('click', function () {
    setTimeout(remSpinner, 1500);
  });
}

function remSpinner() {
  $(".pplr_adding").removeClass("pplr_adding");
}

function updPriceinSticky() {
  const target = $('.t4s-product-price').get(0);
  if (!target) return;
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        $('.stickyprice').first().text($(mutation.target).text());
      }
    }
  });
  observer.observe(target, { childList: true, subtree: true });
}

function updCartCountinSticky() {
  const target = $('[data-cart-count]').get(0);
  if (!target) return;
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        $('.stickyprice').first().text($(mutation.target).text());
      }
    }
  });
  observer.observe(target, { childList: true, subtree: true });
}

// safe executor
function $se(func) {
  try {
    func();
    console.log((func.name || 'anonymous') + ' executed successfully');
  } catch (error) {
    console.error(`An error happened in ${func.name || 'anonymous'} function`);
    console.error(error);
  }
}

// helper
function extractNumericValue(currencyString) {
  const str = (currencyString || '').toString();
  const match = str.match(/[-+]?\d{1,3}(?:,\d{3})*(?:\.\d+)?/);
  return match ? parseFloat(match[0].replace(/,/g, '')) : 0;
}

function showNotifModal(message) {
  if (modalShown) return;
  $('.overlay').fadeIn();
  $('.modal').fadeIn();
  $('.modal .modal-body').html(message);
  $('.closeNotificationButton').on('click', function () {
    $('.overlay, .modal').fadeOut();
  });
  modalShown = true;
}

function levenshteinDistance(e, n) {
  const t = e.length, l = n.length, r = Array.from({ length: t + 1 }, () => Array(l + 1).fill(0));
  for (let f = 0; f <= t; f++)
    for (let t2 = 0; t2 <= l; t2++)
      if (0 === f) r[f][t2] = t2;
      else if (0 === t2) r[f][t2] = f;
      else {
        const l2 = e[f - 1] === n[t2 - 1] ? 0 : 1;
        r[f][t2] = Math.min(r[f - 1][t2] + 1, r[f][t2 - 1] + 1, r[f - 1][t2 - 1] + l2);
      }
  return r[t][l];
}

function areGroupsEqual(group1, group2) {
  if (!group1 || !group2) return false;
  if (group1 == "Linen-Copper" && group2 == "Linen") return true;
  const tolerance = 2;
  const errormargin = levenshteinDistance(group1.toLowerCase(), group2.toLowerCase());
  return errormargin <= tolerance;
}

function groupColors(notDefaultlist = false, retry = true) {
  const colorsList = $(notDefaultlist ? notDefaultlist : 'span[name="properties[Color]"]');
  const parentdiv = colorsList.first().closest('div');
  let listType;
  if (parentdiv.hasClass('img_thumb_dropdown')) listType = 'dropdown';
  else if (parentdiv.hasClass('img_thumb_big')) listType = 'bigThumb';
  if (!listType) {
    if (notDefaultlist) {
      if (retry) {
        setTimeout(function () {
          groupColors(false, false);
        }, 1500);
        return;
      }
      return ("No list found");
    } else {
      groupColors('span[name="properties[Colors]"]', retry);
    }
  }
  switch (listType) {
    case 'bigThumb':
      groupBigThumb(colorsList, notDefaultlist);
      break;
    default:
      console.warn("a List was found but type not defined");
  }
}

function groupBigThumb(colorsList, ndl = false) {
  var currentGroup = null;
  colorsList.each(function () {
    var element = $(this);
    var dataVal = element.attr('data-val');
    let elementGroup = dataVal.split(' ')[1] == "Velvet" ? dataVal.split(' ').slice(0, 2).join(' ') : dataVal.split(' ')[0];
    if (!areGroupsEqual(elementGroup, currentGroup)) {
      $(this).before(`<span style="z-index: 2; width:100%" class="pplr-swatch-element ">
            <h5 class="separator"> </h5> <h5 class="group_text"> <ins class=${ndl ? "wbg" : "dbg"}> ${elementGroup} </ins> </h5>
            </span>`);
      currentGroup = elementGroup;
    }
  });
}

function showProperDimensions() {
  var isSmall;
  var sizeSelection = "none";
  var depthSelection = "none";

  $('span[name="properties[Size]"]').click(function () {
    let bedSelected = $(this).text().toLowerCase();
    if (bedSelected.includes("small") || bedSelected.includes("single")) isSmall = true;
    else isSmall = false;
    const sizes = ["2ft6", "3ft", "4ft6", "4ft", "5ft", "6ft"];
    for (let i = 0; i < sizes.length; i++) {
      if (bedSelected.includes(sizes[i])) {
        sizeSelection = sizes[i];
        break;
      }
    }
    highlightDimTable(sizeSelection, "standard");
  });
  $('span[name="properties[S Depth]"], span[name="properties[S Type]"],  span[name="properties[L Type]"], span[name="properties[L Depth]"]').click(function () {
    let depthSelected = $(this).text().toLowerCase();

    if (depthSelected.includes("depth")) {
      const depth = ["standard", "super", "deep"];
      for (let i = 0; i < depth.length; i++) {
        if (depthSelected.includes(depth[i])) {
          depthSelection = depth[i];
          break;
        }
      }
    }
    else if (!depthSelected.includes("ottoman")) return highlightDimTable(sizeSelection, "standard");
    highlightDimTable(sizeSelection, depthSelection);
  });
}

function highlightDimTable(sz, dp) {
  let tableID;
  if (!dp || dp != "none") {
    $("#stdBedTblDiv").fadeOut();
    $("#xdeepBedTblDiv").fadeOut();
    $("#sdeepBedTblDiv").fadeOut();
  }
  switch (dp) {
    case "standard": tableID = "stdBedTbl"; break;
    case "super": tableID = "sdeepBedTbl"; break;
    case "deep": tableID = "xdeepBedTbl"; break;
  }
  $(`#${tableID}Div`).fadeIn();
  processTableRows(sz);
}

function processTableRows(sz, table = null) {
  $("tr").removeClass("highlightDimension dimDimension");
  var tableSelectors = ["#xdeepBedTbl", "#stdBedTbl", "#sdeepBedTbl"];
  tableSelectors.forEach(function (tableSelector) {
    if (table && table != tableSelector) return;
    $(`${tableSelector} tbody tr`).each(function () {
      var rowText = $(this).text().toLowerCase();

      if (rowText.includes(sz)) {
        if (sz !== "4ft") {
          $(this).addClass("highlightDimension");
        } else {
          if (sz === "4ft" && !rowText.includes("4ft6")) {
            $(this).addClass("highlightDimension");
          } else {
            $(this).addClass("dimDimension");
          }
        }
      } else {
        $(this).addClass("dimDimension");
      }
    });
  });
}

function hidePriceWhenZero() {
  const priceObs = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target.textContent.trim() == "£0.00") {
        $(mutation.target).fadeOut();
      } else {
        $(mutation.target).fadeIn();
      }
    });
  });
  const priceElements = document.getElementsByClassName('t4s-product-price');
  for (const element of priceElements) {
    priceObs.observe(element, { subtree: true, characterData: true, childList: true });
  }
  $('.t4s-cart_price').text($('.t4s-cart_price').text().replace('£0.00', ''));
}

function showThumbsOnDrp() {
  $('.drpMat').on('click', updateDrpMenuBg);
  setTimeout(initDrpMenu, 500);
}

function updateDrpMenuBg() {
  let parentDiv = $(this).closest('div');
  let menu = parentDiv.prevAll('span.pplr-selecter-selected.dropdowncolor').first();

  if (menu.length > 0) {
    menu.attr('style', `background-image: url("${$(this).data('image')}");`);
  } else {
    menu.attr('style', `background-size: auto !important;`);
  }
}

function initDrpMenu() {
  $('span.pplr-selecter-selected.dropdowncolor').each(function () {
    if ($(this).text().trim() === '') {
      $(this).text('-- Please select --');
    }
    let dataPsrcValue = findImgDataPsrc($(this));
    if (dataPsrcValue !== null) {
      $(this).attr('style', `background-image: url("${dataPsrcValue}");`);
    } else {
      $(this).attr('style', `background-size: auto !important;`);
    }
  });
}

function findImgDataPsrc(spanElement) {
  let prevImg = spanElement.prevAll('img[data-psrc]').first();
  if (prevImg.length > 0) {
    return prevImg.attr('data-psrc');
  } else {
    return null;
  }
}

function forceImageInDrpDwn__trigger() {
  let selectedSpans = $(".img_thumb_dropdown span[name^='properties']");
  selectedSpans.each(function () {
    let imageUrl = $(this).data('image');
    $(this).addClass("drpMat");
    $(this).attr('style', function (i, style) {
      return (style && style.endsWith('background-image: url("' + imageUrl + '") !important;')) ? style :
        (style || '') + 'background-image: url("' + imageUrl + '") !important;';
    });
  });
}

function applyBg(item, addClass = null) {
  let options = $(`span[name="properties[${item}]"]`);
  options.each(function () {
    let imageUrl = $(this).data('image');
    if (addClass) $(this).addClass("drpMat");
    $(this).attr('style', function (i, style) {
      return (style && style.endsWith('background-image: url("' + imageUrl + '") !important;')) ? style :
        (style || '') + 'background-image: url("' + imageUrl + '") !important;';
    });
  });
}

function forceImageInDrpDwn() {
  $('.pplr-selecter-selected.dropdowncolor').on('click', forceImageInDrpDwn__trigger);
  forceImageInDrpDwn__trigger();
  $('.dropdowncolor').each(function () {
    $(this).addClass("dropdownfixBg");
  });
}

// ------------ Hide COD discount list item completely ------------
function maskCODOrderDiscountLine() {
  // Inject CSS once
  if (!document.getElementById('cod-hide-style')) {
    const css = `.cod-hide-discount { display: none !important; }`;
    $('<style id="cod-hide-style"></style>').text(css).appendTo(document.head);
  }

  const apply = () => {
    $('li.t4s-order_cart_discounts').filter(function () {
      return $(this).text().indexOf(CODCoupon) !== -1; // e.g., "COD5%(-£47.50)"
    }).addClass('cod-hide-discount');
  };

  // Initial + delayed retries (cart page often re-renders after ready)
  apply();
  setTimeout(apply, 250);
  setTimeout(apply, 750);
  const intervalId = setInterval(apply, 500);
  setTimeout(() => clearInterval(intervalId), 8000);

  // Observe dynamic changes (drawer/page updates)
  const obs = new MutationObserver(apply);
  obs.observe(document.body, { childList: true, subtree: true, characterData: true });
}

